// src/pages/CurriculumPage.jsx
import React, { useEffect, useState } from 'react';
import HeaderRouter from '../components/HeaderRouter';
import Footer from '../components/Footer';
import './CurriculumPage.css';
import { getCurriculumData } from '../api/studentApi';
import LoadingSpinner from '../components/LoadingSpinner';


export default function CurriculumPage() {

    const [curriculumData, setCurriculumData] = useState(null);
    const [activeGrade, setActiveGrade] = useState(null);
    const [currentGradeData, setCurrentGradeData] = useState(null);

    const fetchCurriculmData = async () => {
        const response = await getCurriculumData();
        setCurriculumData(response.data);
        if (curriculumData && curriculumData.length > 0) {
            setActiveGrade(curriculumData[0].grade); // 🌟 Set default grade pill safely here
        }
    };

    useEffect(() => {
        fetchCurriculmData();
    }, []);

    useEffect(() => {
        if (curriculumData) {
            setActiveGrade(curriculumData[0].grade);

        }
    }, [curriculumData]);

    useEffect(() => {
        if (curriculumData) {
            setCurrentGradeData(curriculumData.find(g => g.grade === activeGrade));
        }
    }, [activeGrade, curriculumData]);

    if (!curriculumData || curriculumData.length === 0) {
        return (
            <div className="curriculum-page-wrapper">
                <HeaderRouter />
                <div style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '50vh'
                }}>
                    <LoadingSpinner />
                </div>
                <Footer />
            </div>
        );
    };

    return (
        <div className="curriculum-page-wrapper">
            <HeaderRouter />
            <main className="curriculum-main-content">
                <header className="directory-hero-split">
                    <div className="hero-text-content">
                        <h1>Explore Our Curriculum</h1>
                        <p>
                            Dive into structured primary and secondary educational pathways designed
                            specifically for concept mastery and long-term academic growth.
                        </p>
                    </div>
                    <div className="hero-image-container">
                        <img
                            src="https://storage.googleapis.com/kbadge/site/og-image.png"
                            alt="Interactive science, math, and education subject concept graphic background"
                            className="hero-vector-illustration"
                        />
                    </div>
                </header>

                {/* Grade Selector Navigation Pills */}
                <div className="grade-pill-navigation">
                    {curriculumData.map((group) => (
                        <button
                            key={group.grade}
                            className={`grade-nav-pill ${activeGrade === group.grade ? 'active' : ''}`}
                            onClick={() => {
                                setActiveGrade(group.grade);
                            }}
                        >
                            {group.grade}
                        </button>
                    ))}
                </div>

                {/* Interactive Subject Grid Map */}
                <section className="subject-directory-grid">
                    {currentGradeData?.subjects.map((subject) => (
                        <div
                            key={subject.id}
                            className="subject-tier-card balanced-view"
                            style={{ '--subject-accent': subject.color }}
                        >
                            <div className="subject-card-header">
                                <div className="subject-title-block">
                                    <span className="subject-icon-bullet" style={{ color: subject.color }}>◆</span>
                                    <h3>{subject.name}</h3>
                                </div>
                                <span className="topic-badge-count">{subject.topics.length} Units</span>
                            </div>

                            {/* Balanced Flow Grid */}
                            <div className="topics-balanced-grid">
                                {subject.topics.map((topic) => (
                                    <div key={topic.id} className="balanced-topic-item">
                                        <span className="topic-dot" style={{ backgroundColor: subject.color }}></span>
                                        <span className="topic-text-name">{topic.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </section>
            </main>

            <Footer />
        </div>
    );
}